import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import WristPersonalize from './personalize/WristPersonalize';
import ThumbPersonalize from './personalize/ThumbPersonalize';
import LiningPersonalize from './personalize/LiningPersonalize';
import StampingPersonalize from './personalize/StampingPersonalize';
import { withTranslation } from 'react-i18next';

const Components = {
  Wrist: WristPersonalize,
  Thumb: ThumbPersonalize,
  Lining: LiningPersonalize,
  Stamping: StampingPersonalize,
};

const Items = {
  'Single Welting': [
    'Wrist',
    'Thumb',
    'Lining',
    'Stamping',
  ],
  'Double Welting': [
    'Wrist',
    'Thumb',
    'Lining',
    'Stamping',
  ],
  'First Baseman Mitt': [
    'Wrist',
    'Thumb',
    'Lining',
    'Stamping',
  ],
  'Catchers Mitt': [
    'Wrist',
    'Thumb',
    'Lining',
    'Stamping',
  ],
  Softball: [
    'Wrist',
    'Thumb',
    'Lining',
    'Stamping',
  ],
};

class PersonalizePanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: 'Wrist',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ activeItem: 'Wrist' });
  }

  onSelectItem(item) {
    this.setState({ activeItem: item });
  }

  render() {
    const { isActive, gloveType ,t} = this.props;
    const { activeItem } = this.state;
    const ActiveComponent = Components[activeItem];

    if (!isActive) { return null; }

    return (
      <div className="glove-panel-step clearfix">
        <div className="step-item-tab-view-wrap pull-left">
          {Items[gloveType].map((item) => {
            if (typeof item === 'object') {
              return (<div
                key={item.key}
                className={classNames('glove-step-item-tab', { active: activeItem === item.key })}
                onClick={() => this.onSelectItem(item.key)}
              >
                {item.name}
              </div>);
            }
              return (<div
                key={item}
                className={classNames('glove-step-item-tab', { active: activeItem === item })}
                onClick={() => this.onSelectItem(item)}
              >
                {t(item.toLowerCase().replace(/(\s*)/g, ""))}
              </div>);
          })}
        </div>
        <ActiveComponent />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  gloveType: state.glove.gloveType,
});

export default connect(mapStateToProps)(withTranslation()(PersonalizePanel));
